import classNames from 'classnames';
import type { PropsWithChildren } from 'react';

import './Alert.scss';

type AlertType = 'danger' | 'warning' | 'info' | 'success' | 'info-no-border';
type AlertProps = {
  id?: string;
  type?: AlertType;
  role?: string;
  className?: string;
};

function Alert({
  children,
  type = 'info',
  role = 'alert',
  className,
  ...other
}: PropsWithChildren<AlertProps>) {
  return (
    <div
      className={classNames('Alert', `Alert--${type}`, className)}
      role={role}
      {...other}
    >
      {children}
    </div>
  );
}

export { Alert, type AlertType };
